import BlogTemplate from 'components/article-card/article-card.twig';
import ShowMore from 'components/show-more';
import TagsForm from 'components/tags';

const wrapper = document.querySelector('.j-blog');

if (wrapper) {
    const blogList = wrapper.querySelector('.j-blog-list');
    const blogMore = wrapper.querySelector('.j-blog-more-btn');
    const tagsForm = wrapper.querySelector('.j-tags-form');

    const blogOptions = {
        template          : BlogTemplate,
        button            : blogMore,
        listWrapper       : blogList,
        itemClass         : '.j-article-item',
        nodesAfterLastItem: 1,
        url               : '/api/articles/',
        customForm        : tagsForm
    };

    // Показать больше
    if (blogList && blogMore) {
        new ShowMore(blogOptions).init();
    }

    // Фильтрация по тегам
    if (tagsForm) {
        new TagsForm().init({
            contentWrapper: blogList,
            moreBtn       : blogMore,
            form          : tagsForm
        });
    }
}

